// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"594":"cc86177c","901":"96a4b438"}[chunkId] + ".css";
};